import { useFormik } from "formik";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Card,
    CardBody,
    Container,
    Input, Label,
    Row
} from "reactstrap";
import * as Yup from "yup";
import { instantRateBookingBreadcrumb } from "../../common/data/parties";
import { convertCurrency, convertToINR, getCurrencySymbol, isObjectEmpty, useMobileView } from "../../components/Common/CommonLogic";
import ConfirmationModal from "../../components/Common/ConfirmationModal";
import { showErrorToast } from "../../components/Common/CustomToast";
import { GET_STATE_ALL_TYPE } from "../../store/Global/actiontype";
import { getInstantRateLocation, postCreateInstantBooking } from "../../store/InstantRate/actions";
import { GET_AIR_LOCATION_TYPE, QUOTATION_RESULT_SELECTED_BLANK } from "../../store/InstantRate/actionType";
import { getCustomersCityData } from "../../store/Parties/actions";
import { getVendorCarrierDataAction } from "../../store/Parties/Vendor/action";
import { getTenantQuotationSummeryById, postTransferStatusData } from "../../store/Sales/actions";
import { BLANK_MODAL_CHARGE } from "../../store/Sales/Quotation/actiontype";
import { getCompanyCityData, getTenantInfoData } from "../../store/Settings/actions";
import { SETTINGS_INITIALIZE } from "../../store/Settings/actiontype";
import { getAirOriginalQuoteData, getOriginalQuoteData } from "../../Utils/QuotationsChargesUtils";
import { bookingValidationSchema } from "../../Utils/Schema";
import {
    BID_ACCEPTED,
    BOOKING_REQUESTED, CONSIGNEE_INFORMATION,
    locationTypeMap,
    SHIPPER_INFORMATION
} from "../Dashboard/Partials/initialData";
import TopBreadcrumbs from "../Settings/Surcharge/TopBreadcrumbs";
import ConsigneeForm from "./Components/NewConsigneeForm";
import BillingInformation from "./partials/BillingInformation";
import ShipmentInformationForm from "./partials/ShipmentInformationForm";
import TenantsInformationForm from "./partials/TenantsInformationForm";




const BookingForm = () => {

    const [isInsuranceChecked, setIsInsuranceChecked] = useState(false);
    const [activeAccordionKey, setActiveAccordionKey] = useState("flightDetails");
    const [height, setHeight] = useState(window.innerHeight);
    const isMobile = useMobileView();
    const [open, setOpen] = useState('flightDetails');
    const [openInner, setOpenInner] = useState('');
    const quoteData = useSelector((state) => state.instantRate.quote_selected_data);
    const { vendor_carrier_data, vendor_loader } = useSelector((state) => state?.vendor);
    const { searchForm, instantRateLocation, incoterm, airLocation, $instantActiveTab, instantInquiryId, quote_selected_tenantdata } = useSelector((state) => state.instantRate);
    const { status_master, reason_master, oceanPort_data, vendor_data, UOM_data, currency_data, container_data, country_master } = useSelector(state => state?.globalReducer);
    const mainChargeObj = useSelector((state) => state?.quotation?.mainChargeObj);
    const { inquiry_data_loader, activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const navigateState = useLocation();
    const [isAtBottom, setIsAtBottom] = useState(false);
    const [scrollPos, setScrollPos] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null); // Ref to measure height dynamically
    const [isCustomsOriginChecked, setIsCustomsOriginChecked] = useState(false);
    const [isCustomsDestinationChecked, setIsCustomsDestinationChecked] = useState(false);
    const { currency_ExchangeRate } = useSelector((state) => state.quotation);
    const { settings_companydetails_data, settings_companyCity_data, tenant_info, settings_companyState_data, settings_companyCountry_data, settings_companyPincode_data } = useSelector((state) => state?.settings);
    const [item, setItem] = useState(null);
    const [inquiryId, setInquiryId] = useState(null);
    const [bookingType, setBookingType] = useState('');
    const [bookingFrom, setBookingFrom] = useState('');
    const [summaryItem, setSummaryItem] = useState(null);
    const [billingInfo, setBillingInfo] = useState({});
    const [errorItem, setErrorItem] = useState({});
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [bookingRequestTitle] = useState('Confirm Booking Request');
    const [bookingRequestMessage] = useState('Please review the shipment details carefully. Once submitted, the request will be sent to the freight agent for approval.');
    const [bookingRequestShortMesssage] = useState('A confirmation email will be sent to you once the agent accepts this request.');
    const [bookingRequestButtonText] = useState('Submit Booking Request');
    const [id, setId] = useState('');
    const [version, setVersion] = useState('');
    const [originPortCountry, setOriginPortCountry] = useState('');
    const [destinationPortCountry, setDestinationPortCountry] = useState('');

    useEffect(() => {
        dispatch({ type: SETTINGS_INITIALIZE });
        if (vendor_carrier_data?.content === undefined) {
            dispatch(getVendorCarrierDataAction(''));
        }
        dispatch(getCompanyCityData());
        dispatch(getTenantInfoData());
        dispatch({ type: GET_STATE_ALL_TYPE });
        if (airLocation && airLocation?.content === undefined) {
            dispatch({ type: GET_AIR_LOCATION_TYPE });
        }
    }, [dispatch]);

    useEffect(() => {
        console.log(navigateState?.state, "navigateState?.state");
        if (navigateState?.state?.item && navigateState?.state?.instantInquiryId) {
            dispatch(getInstantRateLocation());
            console.log(navigateState?.state, "navigateState?.state");
            //console.log(navigateState?.state?.item?.inquiryId, "navigateState?.state?.item?.inquiryId");
            setBookingFrom(navigateState?.state?.bookingFrom || '');
            setSummaryItem(navigateState?.state?.summaryItem || null);
            setItem(navigateState?.state?.item)
            setInquiryId(navigateState?.state?.instantInquiryId);
            setBookingType(navigateState?.state?.bookingType);
            //
            console.log(searchForm, "searchForm");
            console.log(Number(navigateState?.state?.item?.originId), "Number(navigateState?.state?.item?.originId)");
            if (navigateState?.state?.bookingType === 'air') {
                console.log(airLocation, "Air Locations");
                const originCountry = airLocation?.find(item => Number(item?.id) === Number(searchForm?.location_from?.id))?.country;
                console.log(originCountry, "originCountry");
                setOriginPortCountry(originCountry)
                const destinationCountry = airLocation?.find(item => Number(item?.id) === Number(searchForm?.location_to?.id))?.country;
                console.log(destinationCountry, "destinationCountry");
                setDestinationPortCountry(destinationCountry);
            } else {
                const originCountry = oceanPort_data?.find(item => Number(item?.id) === Number(searchForm?.location_from?.value))?.country;
                console.log(originCountry, "originCountry");
                setOriginPortCountry(originCountry)
                const destinationCountry = oceanPort_data?.find(item => Number(item?.id) === Number(searchForm?.location_to?.value))?.country;
                console.log(destinationCountry, "destinationCountry");
                setDestinationPortCountry(destinationCountry);
            }
        } else {
            setItem(null);
            setInquiryId(null);
            setBookingType('');
        }
    }, [navigateState, oceanPort_data, airLocation])

    useEffect(() => {
        console.log(activeQuotationsViewDetails, "activeQuotationsViewDetails");

        if (activeQuotationsViewDetails?.inquiryField) {
            setIsCustomsOriginChecked(activeQuotationsViewDetails?.isCustomsAtOrigin);
            setIsCustomsDestinationChecked(activeQuotationsViewDetails?.isCustomsAtDestination);
            setIsInsuranceChecked(activeQuotationsViewDetails?.isInsuranceRequired);

            if (activeQuotationsViewDetails?.inquiryField?.originType === 'OCEAN_PORT') {
                const originCountry = oceanPort_data?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.inquiryField?.originPortId))?.country;
                setOriginPortCountry(originCountry);
                console.log(originCountry, "originCountry");
            }

            if (activeQuotationsViewDetails?.inquiryField?.destinationType === 'OCEAN_PORT') {
                const destinationCountry = oceanPort_data?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.inquiryField?.destinationPortId))?.country;
                setDestinationPortCountry(destinationCountry);
                console.log(destinationCountry, "destinationCountry");
            }

            if (activeQuotationsViewDetails?.inquiryField?.originType === 'ICD') {
                const originCountry = country_master?.find(item => Number(item?.id) === Number(instantRateLocation?.find(loc => Number(loc?.id) === Number(activeQuotationsViewDetails?.inquiryField?.originIcdId))?.countryId));
                setOriginPortCountry(originCountry);
                console.log(originCountry, 'originCountry - icd');
            }
             if (activeQuotationsViewDetails?.inquiryField?.destinationType === 'ICD') {
                const destinationCountry = country_master?.find(item => Number(item?.id) === Number(instantRateLocation?.find(loc => Number(loc?.id) === Number(activeQuotationsViewDetails?.inquiryField?.destinationIcdId))?.countryId));
                setDestinationPortCountry(destinationCountry);
                console.log(destinationCountry, 'destinationCountry - icd');
            }

            if (activeQuotationsViewDetails?.inquiryField?.originType === 'AIR_PORT') {
                const originCountry = airLocation?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.inquiryField?.originPortId))?.country;
                setOriginPortCountry(originCountry);
            }

            if (activeQuotationsViewDetails?.inquiryField?.destinationType === 'AIR_PORT') {
                const destinationCountry = airLocation?.find(item => Number(item?.id) === Number(activeQuotationsViewDetails?.inquiryField?.destinationPortId))?.country;
                setDestinationPortCountry(destinationCountry);
            }

        }
    }, [activeQuotationsViewDetails, airLocation, oceanPort_data])


    useEffect(() => {
        //console.log(quote_selected_tenantdata, "quote_selected_tenantdata");
        //console.log(quote_selected_tenantdata?.id, "quote_selected_tenantdata?.id");
        //console.log(quote_selected_tenantdata?.version, "quote_selected_tenantdata?.version");
        if (quote_selected_tenantdata) {
            //console.log(quote_selected_tenantdata?.id, "quote_selected_tenantdata?.id");
            //console.log(quote_selected_tenantdata?.version, "quote_selected_tenantdata?.version");
            setId(quote_selected_tenantdata?.id);
            setVersion(quote_selected_tenantdata?.version);
        }
    }, [quote_selected_tenantdata]);

    useEffect(() => {
        if (bookingFrom === 'viewBids' && summaryItem?.id) {
            dispatch(getTenantQuotationSummeryById(summaryItem?.id));
        }
    }, [bookingFrom, summaryItem])

    useEffect(() => {
        dispatch(getCustomersCityData());
        if (contentRef.current) {
            contentRef.current.style.height = isExpanded
                ? `${contentRef.current.scrollHeight}px`
                : "0px";
        }
    }, [isExpanded]);

    useLayoutEffect(() => {
        const handleResize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggle = (id) => {
        if (open !== id) {
            setOpen(id);
        }
    };

    const blankFieldHandle = () => {
        dispatch({ type: BLANK_MODAL_CHARGE, payload: {} });
        dispatch({ type: QUOTATION_RESULT_SELECTED_BLANK, payload: {} });
    }

    // ---------------- SubTotal / Total and Tax ------------------------------
    const innerTotalHandler = (array, newArray) => {
        return array?.reduce((total, charge) => total + convertToINR(Number(charge?.total_sale_cost) || (Number(charge.amount + (charge?.taxDetail?.value || 0))), charge.currencyCode), 0) + (newArray !== undefined ? newArray?.reduce((total, charge) => total + convertToINR(Number(charge?.total_sale_cost), charge.currencyCode), 0) : 0);
    }

    const subTotalHandler = (quoteObject) => {
        if (bookingType === 'ocean_fcl') {
            let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

            const totalSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
                let innerSum = 0;
                if (currentOuter?.selected) {
                    innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                        return accInner + convertCurrency(currentInner, Number(currentInner.amount), currency_ExchangeRate, searchForm);
                    }, 0);
                }
                return accOuter + innerSum;
            }, 0);

            const totalAmount = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
                let innerSum = 0;
                if (currentOuter?.selected) {
                    innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                        return accInner + convertCurrency(currentInner, Number(currentInner.amount), currency_ExchangeRate, searchForm);
                    }, 0);
                }
                return accOuter + innerSum;
            }, 0);
            return totalSum || 0 + totalAmount || 0;
        }

        if (bookingType === 'air') {
            const totalSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
                let innerSum = 0;
                if (currentOuter?.selected) {
                    innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                        return accInner + Number(currentInner.amount);
                    }, 0);
                }
                return accOuter + innerSum;
            }, 0);

            const totalAmount = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
                let innerSum = 0;
                if (currentOuter?.selected) {
                    innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                        return accInner + Number(currentInner.amount);
                    }, 0);
                }
                return accOuter + innerSum;
            }, 0);
            return totalSum || 0 + totalAmount || 0;
        }


        // const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
        //     let innerSum = 0;
        //     if (currentOuter?.selected) {
        //         innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
        //             return accInner + (convertToINR(currentInner?.margin_value ? Number(currentInner.margin_value) : 0, currentInner.currencyCode) || 0);
        //         }, 0);
        //     }
        //     return accOuter + innerSum;
        // }, 0);
        /*
        const newSubTotal = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                let totalAmt = Number(currentInner.unitPerPrice || 0) * Number(currentInner.unit || 1);
                return accInner + convertToINR(Number(totalAmt), currentInner.currencyCode);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;

        const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + (convertToINR(currentInner?.margin_value ? Number(currentInner.margin_value) : 0, currentInner.currencyCode) || 0);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;
        */
        //return totalSum + newSubTotal + totalMarginSum + totalNewMarginSum;
        //console.log(totalSum, "totalSum" , totalMarginSum, 'totalMarginSum');

    }

    // ----------------- preview quotation -------------------
    const previewQuotationHandler = () => {
        //console.log(quoteData, "quoteData");
        //console.log(mainChargeObj, "mainChargeObj");
        // setPreviewModal(true);
        //QuoteModalHandler();
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollableHeight =
                document.documentElement.scrollHeight - window.innerHeight;
            const scrolled = window.scrollY;

            // Track if user has scrolled to bottom
            if (scrolled >= scrollableHeight - 50) {
                setIsAtBottom(true);
            } else {
                setIsAtBottom(false);
            }

            // Save scroll position
            setScrollPos(scrolled);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleToggle = (key) => {
        // Prevent closing the last open tab
        setActiveAccordionKey(activeAccordionKey === key ? activeAccordionKey : key);
    };

    const proceedToNext = (stepKey) => {
        toggle(stepKey);
    }

    const pickupAddressFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            pickupAddressNeeded: false,
            pickupAddress: "",
            state: "",
            zipcode: "",
            city: "",
        },
        validationSchema: Yup.object({
            pickupAddress: Yup.string().required("Required"),
            state: Yup.string().required("Required"),
            zipcode: Yup.string().required("Required"),
            city: Yup.string().required("Required"),
        })
    });

    const deliveryAddressFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            deliveryAddressNeeded: false,
            deliveryAddress: "",
            state: "",
            zipcode: "",
            city: "",
        },
        validationSchema: Yup.object({
            deliveryAddress: Yup.string().required("Required"),
            state: Yup.string().required("Required"),
            zipcode: Yup.string().required("Required"),
            city: Yup.string().required("Required"),
        })
    });

    const additionalServiceValidationCheck = async () => {
        const isPickupNeeded = pickupAddressFormik?.values.pickupAddressNeeded;
        const isDeliveryNeeded = deliveryAddressFormik?.values.deliveryAddressNeeded;

        let isPickupValid = true;
        let isDeliveryValid = true;

        if (isPickupNeeded) {
            const pickupErrors = await pickupAddressFormik.validateForm();
            isPickupValid = isObjectEmpty(pickupErrors);
            if (!isPickupValid) {
                await pickupAddressFormik.submitForm();
            }
        }

        if (isDeliveryNeeded) {
            const deliveryErrors = await deliveryAddressFormik.validateForm();
            isDeliveryValid = isObjectEmpty(deliveryErrors);
            if (!isDeliveryValid) {
                await deliveryAddressFormik.submitForm();
            }
        }

        // Proceed only if all required validations pass
        if ((!isPickupNeeded || isPickupValid) && (!isDeliveryNeeded || isDeliveryValid)) {
            proceedToNext("customerdetails");
        }
    }

    useEffect(() => {
        //console.log(searchForm, "searchForm");
    }, [searchForm])

    const overAllMarginHandler = (quoteObject, subtotalvalue) => {
        let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

        const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = 0;
            if (currentOuter?.selected) {
                innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                    return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
                }, 0);
            }
            return accOuter + innerSum;
        }, 0);

        const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
            let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, searchForm);
            }, 0);
            return accOuter + innerSum;
        }, 0) : 0;


        let totalMargin = totalMarginSum + totalNewMarginSum;
        let buyvalue = subtotalvalue - totalMargin

        return (totalMargin * 100 / buyvalue).toFixed(2) || 0;
    }


    const bookingFormFormik = useFormik({
        enableReinitialize: true,
        validationSchema: bookingValidationSchema,
        initialValues: {
            //Shipment Details
            origin_city: searchForm?.location_from?.locationType === "CITY" && searchForm?.location_from?.label,
            destination_city: searchForm?.location_to?.locationType === "CITY" && searchForm?.location_to?.label,
            origin_port: $instantActiveTab?.sub === 'dom_air' ? searchForm?.location_from?.label : searchForm?.location_from?.locationType === "PORT" ? searchForm?.location_from?.label : quoteData?.[0]?.tariffDetails?.[0]?.to,
            destination_port: $instantActiveTab?.sub === 'dom_air' ? searchForm?.location_to?.label : searchForm?.location_to?.locationType === "PORT" ? searchForm?.location_to?.label : quoteData?.[0]?.tariffDetails?.[quoteData?.[0]?.tariffDetails?.length - 1 || 0]?.from,
            cargo_type: searchForm?.cargo_type?.value || '-',
            commodity: "",
            cargo_value: searchForm?.cargo_value?.value || '',
            incoterms: searchForm?.incoterm?.label || '',

            container_type: searchForm?.container_type?.containerArray?.length !== 0 ? searchForm?.container_type?.containerArray?.map((item) => ({
                quantity: item?.unitNew,
                type: item?.label
            })) : '',
            gross_weight: $instantActiveTab?.sub === 'dom_air' ? searchForm?.shipment_details?.weight || 0 + " " + (searchForm?.shipment_details?.cargo_weight?.weight_unit || '') : (searchForm?.container_type?.cargo_weight?.value || 0) + " " + (searchForm?.container_type?.cargo_weight?.weight?.value || ''),

            shipment_details: searchForm?.shipment_details?.array?.length !== 0 ? searchForm?.shipment_details?.array?.map((item) => ({
                type: item?.label,
                length: item?.dimensions_l,
                width: item?.dimensions_w,
                height: item?.dimensions_h,
                dimensions_unit: item?.dimensions_unit,
                weightPerUnit: item?.weightPerUnit,
                weightUOM: item?.weightUOM,
                unit: item?.no_unit,
                volumentric_wt: item?.vWeight?.toFixed(2) || '',
            })) : '',
            quote_currency: { currencyCode: "USD", id: 3, label: "USD - US DOLLAR", value: "US DOLLAR", version: 0 },
            isShipperCopyBillingAddress: false,
            isConsigneeCopyBillingAddress: false,
            //Shipper Information
            isBillingAddress: false,
            firstName: "",
            lastName: "",
            companyName: "",
            contactNumber: "",
            email: "",
            companyAddress: "",
            shipperCityId: '',
            shipperCity: "",
            shipperStateId: '',
            shipperState: "",
            shipperCountryId: '',
            shipperCountry: "",
            shipperZipcode: "",

            //Consignee Information
            consigneeFirstName: '',
            consigneeLastName: '',
            consigneePhoneNumber: '',
            consigneeOpCode: '',
            consigneeEmail: '',
            consigneeCompanyName: '',
            consigneeCompanyAddress: '',
            consigneeCityId: '',
            consigneeCity: '',
            consigneeStateId: '',
            consigneeState: '',
            consigneeCountryId: '',
            consigneeCountry: '',
            consigneeZipcode: '',

            //Billing Address
            billingCustomerName: '',
            billingCustomerAddress: '',
            billingContactName: '',
            billingContactEmail: '',
            billingContactNumber: '',

        },
        validateOnChange: false,     // ✅ disable onChange validation
        validateOnBlur: false,       // ✅ disable onBlur validation
        onSubmit: async (value) => {
            //console.log(quoteData, "quoteData");

            console.log(originPortCountry, "originPortCountry");
            console.log(destinationPortCountry, "destinationPortCountry");

            if (bookingType === 'ocean_fcl') {
                if (originPortCountry?.id !== value?.shipperCountryId) {
                    showErrorToast("Shipper country does not match with origin port");
                    bookingFormFormik.setErrors({
                        ...bookingFormFormik.errors,
                        shipperCity: "Shipper City Does not match with origin port"
                    });
                    return true;
                }

                if (Number(destinationPortCountry?.id) !== Number(value?.consigneeCountryId)) {
                    showErrorToast("Consignee country does not match with destionation port");
                    bookingFormFormik.setErrors({
                        ...bookingFormFormik.errors,
                        consigneeCity: "Consignee City Does not match with destination port"
                    });
                    return true;
                }
            }

            if (bookingType === 'air') {
                if (originPortCountry?.id !== value?.shipperCountryId) {
                    showErrorToast("Shipper country does not match with origin port");
                    bookingFormFormik.setErrors({
                        ...bookingFormFormik.errors,
                        shipperCity: "Shipper City Does not match with origin port"
                    });
                    return true;
                }
                console.log(destinationPortCountry, "destinationPortCountry", Number(value?.consigneeCountryId), "Number(value?.consigneeCountryId)");
                if (Number(destinationPortCountry?.id) !== Number(value?.consigneeCountryId)) {
                    showErrorToast("Consignee country does not match with destionation port");
                    bookingFormFormik.setErrors({
                        ...bookingFormFormik.errors,
                        consigneeCity: "Consignee City Does not match with destination port"
                    });
                    return true;
                }
            }


            let historyData = quoteData.map(data => {
                return {
                    statusTime: new Date().toTimeString().split(' ')[0],
                    statusDate: new Date().toISOString().split('T')[0],
                    reasonMasterId: reason_master?.find(reason => String(reason?.reasonCode) === "INVALID")?.id,
                    statusMasterId: status_master?.find(status => String(status?.statusCode) === BOOKING_REQUESTED)?.id,
                };
            });

            let shipperInfo = {
                "firstName": value?.isShipperCopyBillingAddress ? value?.billingCustomerName?.label : value?.firstName,
                "lastName": value?.isShipperCopyBillingAddress ? '' : value?.lastName,
                "phoneNumber": value?.isShipperCopyBillingAddress ? value?.billingCustomerName?.contactNo : value?.firstName,
                "emailId": value?.isShipperCopyBillingAddress ? value?.billingCustomerName?.contactEmail : value?.firstName,
                "companyName": value?.companyName,
                "addressType": SHIPPER_INFORMATION,
                "address": value?.isShipperCopyBillingAddress ? value?.billingCustomerAddress : value?.companyAddress,
                "cityId": value?.shipperCityId || 0,
                "stateId": value?.shipperStateId || 0,
                "countryId": value?.shipperCountryId || 0,
                "zipcodeId": value?.shipperZipcode || ''
            }

            let consigneeInfo = {
                "firstName": value?.isConsigneeCopyBillingAddress ? value?.billingContactName : value?.consigneeFirstName || '',
                "lastName": value?.isConsigneeCopyBillingAddress ? '' : value?.consigneeLastName || '',
                "phoneNumber": value?.isConsigneeCopyBillingAddress ? value?.billingContactNumber : value?.consigneePhoneNumber || '',
                "emailId": value?.isConsigneeCopyBillingAddress ? value?.billingContactEmail : value?.consigneeEmail || '',
                "companyName": value?.consigneeCompanyName || '',
                "addressType": CONSIGNEE_INFORMATION,
                "address": value?.isConsigneeCopyBillingAddress ? value?.billingCustomerAddress : value?.consigneeCompanyAddress || '',
                "cityId": value?.consigneeCityId || 0,
                "stateId": value?.consigneeStateId || 0,
                "countryId": value?.consigneeCountryId || 0,
                "zipcodeId": value?.consigneeZipcode || 0
            }

            let addedCharges = mainChargeObj.map(data => {
                return {
                    tenantFclQuotationsCarrierCharges: data.tariffDetails.flatMap(charge =>
                        charge.fclTariffBreakDowns.map(breakDown => {
                            return {
                                currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)),
                                chargeHeader: charge?.header,
                                oceanContainer: container_data?.find(container => String(container?.value) === String(breakDown?.containerDetail)),
                                unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.value)),
                                unitCost: breakDown?.unit,
                                totalSaleCost: breakDown?.total_sale_cost,
                                totalBuyCost: breakDown?.total_sale_cost,
                                chargeName: breakDown?.component?.surchargeCategory,
                                markupType: breakDown?.markup_type || "PERCENTAGE",
                                markupValue: breakDown?.markup_val,
                                chargeMarginAmount: breakDown?.margin_value
                            };
                        })
                    )
                };
            });

            let sellerTenantObject = {
                sellerTenantId: quoteData[0]?.tenantId || quote_selected_tenantdata?.tenantFclQuotationSellerTenants?.[0]?.sellerTenantId,
            }
            //console.log(id, version, "id, version");
            let data = {
                tenantFclQuotationSellerTenants: [sellerTenantObject],

                //tenantCustomerId: searchForm?.customerName?.value || parseInt(quoteData[0]?.customerId),
                //contactName: customerInfo?.name || quoteData[0]?.contactName,
                //contactNo: customerInfo?.contactNo || quoteData[0]?.contactNumber,
                //contactEmail: customerInfo?.contactEmail || quoteData[0]?.contactEmail,

                ...(inquiryId !== '' && { inquiryDetailId: inquiryId }),
                ...(id !== '' && { id: id }),
                ...(version >= 0 && { version: version }),

                statusMasterId: status_master?.find(status => String(status?.statusCode) === BOOKING_REQUESTED)?.id,
                tenantFclQuotationStatusHistories: historyData,
                tenantFclQuotationCarrierDetails: quoteData.map((data, index) => {
                    const vendor = vendor_data?.content?.find(vendor => Number(vendor.id) === Number(data?.carrierId));

                    console.log(data, "data");
                    console.log(quoteData, "quoteData");

                    const originalCharges = bookingType === 'ocean_fcl' ?
                        getOriginalQuoteData(data, quoteData, container_data, UOM_data, currency_data)
                        : getAirOriginalQuoteData(data, quoteData, container_data, UOM_data, currency_data);

                    console.log(originalCharges, "originalCharges");

                    const mergedCharges = [
                        ...originalCharges,
                        ...(addedCharges[index]?.tenantFclQuotationsCarrierCharges || [])
                    ];

                    console.log(mergedCharges, "mergedCharges");

                    //{ id: quoteData[0]?.destinationId.toString(), label: quoteData[0]?.destinationName, value: quoteData[0]?.destinationName, version: "0" }
                    // { id: quoteData[0]?.originId.toString(), label: quoteData[0]?.originName, value: quoteData[0]?.originName, version: "0" }
                    //console.log(vendor_carrier_data?.content, "vendor_carrier_data?.content");
                    console.log(data, "data");
                    const result = {
                        carrierMaster: bookingType === 'ocean_fcl' ? getOceanCarrierDetails(data?.carrierId) : getAirCarrierDetails(data?.id),
                        ...(quoteData[0].carrierId && { carrierMaster: vendor_carrier_data?.content?.find(item => item.id === (quoteData[0].carrierId)) }),
                        ...(vendor?.id && { tenantVendorId: vendor?.id }),
                        remarks: data?.remarks,

                        tenantFclQuotationsCarrierCharges: (quoteData?.[0]?.quoteFrom === 'smartQuotation') ? originalCharges : mergedCharges,
                        grossMargin: overAllMarginHandler(data, subTotalHandler(data)),
                        transitTime: data?.oceanTransitTime,
                        detentionFreeOrg: parseInt(data?.detentionFreeOrg),
                        detentionFreeDest: parseInt(data?.detentionFreeDest),
                        viaPorts: data?.viaPorts?.map(item => item?.id).filter(id => id !== undefined).join(','),
                        quotationValidFrom: data?.validFrom,
                        quotationValidTo: data?.validTo,
                        quotationValue: subTotalHandler(data),
                    };

                    if (bookingType === 'ocean_fcl') {
                        result.originLocationType = locationTypeMap[quoteData?.[0]?.originLocationType] || quoteData?.[0]?.originLocationType;
                        result.destinationLocationType = locationTypeMap[quoteData?.[0]?.destinationLocationType] || quoteData?.[0]?.destinationLocationType;
                        result.destinationPortId = searchForm?.location_to?.value || quoteData[0]?.destinationId;
                        result.originPortId = searchForm?.location_from?.value || quoteData[0]?.originId;

                        if (vendor?.city?.id || vendor?.city !== undefined) {
                            result.originCityId = vendor?.city?.id;
                            result.destinationCityId = vendor?.city?.id;
                        }

                        if (quoteData[0]?.originCityId !== 0) {
                            result.originCityId = quoteData[0]?.originCityId;
                        }

                        if (quoteData[0]?.destinationCityId !== 0) {
                            result.destinationCityId = quoteData[0]?.destinationCityId;
                        }
                    }

                    if (bookingType === 'air') {
                        result.originLocationType = 'AIR_PORT';
                        result.destinationLocationType = 'AIR_PORT';
                        result.destinationPortId = searchForm?.location_to?.id || quoteData[0]?.destinationId;
                        result.originPortId = searchForm?.location_from?.id || quoteData[0]?.originId;
                    }

                    return result;
                })
            };
            //console.log(value?.billingCustomerName, "value?.billingCustomerName", tenant_info, "tenant_info");
            let payload = {
                tenantFclQuotationSellerTenants: [sellerTenantObject],
                "reasonMasterId": null,
                "inquiryField": {
                    "cargoValue": value?.cargo_value || 0,
                    "commodityId": value?.commodity?.id || 0,
                    "incotermId": value?.incoterms?.value || 0,
                    "isCustomsAtOrigin": isCustomsOriginChecked,
                    "isCustomsAtDestination": isCustomsDestinationChecked,
                    "isInsurance": isInsuranceChecked,
                    "currencyId": value?.quote_currency?.id,
                },
                "inquiryDetailId": instantInquiryId || inquiryId,
                "statusMasterId": status_master?.find(status => String(status?.statusCode) === BOOKING_REQUESTED)?.id,

                "billingAcctId": value?.billingCustomerName?.value === 'self' ? null : Number(value?.billingCustomerName?.value),
                "rateType": bookingType === 'ocean_fcl' ? "OCEAN_FCL" : "AIR",   // must match your Rate enum
                "tenantBookingStatusHistories": historyData,
                "tenantFclQuotationSummary": data,
                "tenantBookingDetails": [
                    shipperInfo,
                    consigneeInfo,
                ]
            }
            console.log(payload, "Payload");
            dispatch(postCreateInstantBooking(payload));
            if (bookingFrom === 'viewBids') {
                setTimeout(() => {
                    navigate('/my/inquiries');
                }, 300)
            } else {
                setTimeout(() => {
                    navigate('/my/bookings');
                }, 1500);
            }
        }
    });

    // Track if we've already shown an error toast for shipper country
    const [shipperCountryErrorShown, setShipperCountryErrorShown] = useState(false);

    const onShipperCountryChange = (countryId) => {
        if (originPortCountry?.id === undefined) {
            dispatch(getCompanyCityData());
            dispatch({ type: GET_AIR_LOCATION_TYPE });
            dispatch({ type: GET_STATE_ALL_TYPE });
        }
        console.log(originPortCountry, countryId, "originPortCountry countryId")

        // Convert both IDs to numbers for consistent comparison
        const originCountryId = originPortCountry?.id ? Number(originPortCountry.id) : undefined;
        const selectedCountryId = Number(countryId);

        if (bookingType === 'ocean_fcl' || bookingType === 'air') {
            // Only validate if originPortCountry is properly defined
            if (originCountryId !== undefined && originCountryId !== selectedCountryId) {
                console.log(originCountryId, selectedCountryId, "originCountryId selectedCountryId");
                // Only show toast if we haven't shown it already
                if (!shipperCountryErrorShown) {
                    showErrorToast("Shipper country does not match with origin port");
                    setShipperCountryErrorShown(true);
                }
                setTimeout(() => {
                    bookingFormFormik.setErrors({
                        shipperCity: "Shipper City Does not match with origin port"
                    });
                }, 0);
            } else {
                // Clear the error if countries match
                console.log("Match Found");
                // Reset the error shown flag
                setShipperCountryErrorShown(false);

                // Clear the status flag
                if (bookingFormFormik.status?.shipperCityError) {
                    bookingFormFormik.setStatus({
                        ...bookingFormFormik.status,
                        shipperCityError: false
                    });
                }

                // Clear the error directly
                bookingFormFormik.setErrors({
                    ...bookingFormFormik.errors,
                    shipperCity: undefined
                });

                // Reset the touched state
                bookingFormFormik.setFieldTouched("shipperCity", false, false);

                // Force validation to refresh the UI
                setTimeout(() => {
                    bookingFormFormik.validateField('shipperCity');
                }, 0);
            }
        }
    }

    // Track if we've already shown an error toast for consignee country
    const [consigneeCountryErrorShown, setConsigneeCountryErrorShown] = useState(false);

    const onConsigneeCountryChange = async (countryId) => {
        if (destinationPortCountry?.id === undefined) {
            dispatch(getCompanyCityData());
            dispatch({ type: GET_AIR_LOCATION_TYPE });
            dispatch({ type: GET_STATE_ALL_TYPE });
        }

        // Convert both IDs to numbers for consistent comparison
        const destCountryId = destinationPortCountry?.id ? Number(destinationPortCountry.id) : undefined;
        const selectedCountryId = Number(countryId);

        if (bookingType === 'ocean_fcl' || bookingType === 'air') {
            // Only validate if destinationPortCountry is properly defined
            if (destCountryId !== undefined && destCountryId !== selectedCountryId) {
                console.log(destCountryId, selectedCountryId, "destCountryId selectedCountryId");
                // Only show toast if we haven't shown it already
                if (!consigneeCountryErrorShown) {
                    showErrorToast("Consignee country does not match with destination port");
                    setConsigneeCountryErrorShown(true);
                }

                setTimeout(() => {
                    bookingFormFormik.setErrors({
                        consigneeCity: "Consignee City Does not match with destination port"
                    });
                }, 0);

            } else {
                // Clear the error if countries match
                console.log("Consignee Match Found");
                // Reset the error shown flag
                setConsigneeCountryErrorShown(false);

                // Clear the status flag
                if (bookingFormFormik.status?.consigneeCityError) {
                    bookingFormFormik.setStatus({
                        ...bookingFormFormik.status,
                        consigneeCityError: false
                    });
                }

                // Clear the error directly
                bookingFormFormik.setErrors({
                    ...bookingFormFormik.errors,
                    consigneeCity: undefined
                });

                // Reset the touched state
                bookingFormFormik.setFieldTouched("consigneeCity", false, false);

                // Force validation to refresh the UI
                setTimeout(() => {
                    bookingFormFormik.validateField('consigneeCity');
                }, 0);
            }
        }
    }

    const getOceanCarrierDetails = (carrierId) => {
        return vendor_carrier_data?.content?.find(item => item.id === (carrierId));
    }

    const getAirCarrierDetails = (carrierId) => {
        return vendor_carrier_data?.content?.find(item => item.id === (carrierId));
    }

    useEffect(() => {
        if (bookingFormFormik?.values?.shipperCity !== '') {
            const selectedCity = settings_companyCity_data?.content?.find(city => city.cityName === bookingFormFormik?.values?.shipperCity);
            //console.log(selectedCity, "selectedCity");
            if (selectedCity === undefined) {
                bookingFormFormik.setFieldError('shipperCity', 'Please select a valid city from list');
            } else {
                bookingFormFormik.setFieldValue('shipperCityId', selectedCity?.id || 0);
                bookingFormFormik.setFieldValue('shipperCity', selectedCity?.cityName);
            }
        }

        if (bookingFormFormik?.values?.shipperState !== '') {
            const selectedState = settings_companyState_data?.content?.find(state => state.stateName === bookingFormFormik?.values?.shipperState);
            //console.log(selectedState, "selectedState");
            if (selectedState === undefined) {
                bookingFormFormik.setFieldError('shipperState', 'Please select a valid state from list');
            } else {
                bookingFormFormik.setFieldValue('shipperStateId', selectedState?.id || 0);
                bookingFormFormik.setFieldValue('shipperState', selectedState?.stateName || '');
            }
        }

        if (bookingFormFormik?.values?.shipperCountry !== '') {
            const selectedCountry = settings_companyCountry_data?.content?.find(country => country.countryName === bookingFormFormik?.values?.shipperCountry);
            //console.log(selectedCountry, "selectedCountry");
            if (selectedCountry === undefined) {
                bookingFormFormik.setFieldError('shipperCountry', 'Please select a valid country from list');
            } else {
                bookingFormFormik.setFieldValue('shipperCountryId', selectedCountry?.id || 0);
                bookingFormFormik.setFieldValue('shipperCountry', selectedCountry?.countryName || '');
            }
        }

        if (bookingFormFormik?.values?.shipperZipcode !== '') {
            const selectedZipcode = settings_companyPincode_data?.content?.find(zip => zip.pin === bookingFormFormik?.values?.shipperZipcode);
            //console.log(selectedZipcode, "selectedZipcode");
            if (selectedZipcode === undefined) {
                bookingFormFormik.setFieldError('shipperZipcode', 'Please select a valid zipcode from list');
            } else {
                bookingFormFormik.setFieldValue('shipperZipcode', selectedZipcode?.pin || '');
            }
        }

    }, [bookingFormFormik?.values?.shipperCity, bookingFormFormik?.values?.shipperState, bookingFormFormik?.values?.shipperCountry, bookingFormFormik?.values?.shipperZipcode]);


    useEffect(() => {
        if (bookingFormFormik?.values?.consigneeCity !== '') {
            const selectedCity = settings_companyCity_data?.content?.find(city => city.cityName === bookingFormFormik?.values?.consigneeCity);
            //console.log(selectedCity, "selectedCity");
            if (selectedCity === undefined) {
                bookingFormFormik.setFieldError('consigneeCity', 'Please select a valid city from list');
            } else {
                bookingFormFormik.setFieldValue('consigneeCityId', selectedCity?.id || 0);
                bookingFormFormik.setFieldValue('consigneeCity', selectedCity?.cityName);
            }
        }

        if (bookingFormFormik?.values?.consigneeState !== '') {
            const selectedState = settings_companyState_data?.content?.find(state => state.stateName === bookingFormFormik?.values?.consigneeState);
            //console.log(selectedState, "selectedState");
            if (selectedState === undefined) {
                bookingFormFormik.setFieldError('consigneeState', 'Please select a valid state from list');
            } else {
                bookingFormFormik.setFieldValue('consigneeStateId', selectedState?.id || 0);
                bookingFormFormik.setFieldValue('consigneeState', selectedState?.stateName || '');
            }
        }

        if (bookingFormFormik?.values?.consigneeCountry !== '') {
            const selectedCountry = settings_companyCountry_data?.content?.find(country => country.countryName === bookingFormFormik?.values?.consigneeCountry);
            //console.log(selectedCountry, "selectedCountry");
            if (selectedCountry === undefined) {
                bookingFormFormik.setFieldError('consigneeCountry', 'Please select a valid country from list');
            } else {
                bookingFormFormik.setFieldValue('consigneeCountryId', selectedCountry?.id || 0);
                bookingFormFormik.setFieldValue('consigneeCountry', selectedCountry?.countryName || '');
            }
        }

        if (bookingFormFormik?.values?.consigneeZipcode !== '') {
            const selectedZipcode = settings_companyPincode_data?.content?.find(zip => zip.pin === bookingFormFormik?.values?.consigneeZipcode);
            //console.log(selectedZipcode, "selectedZipcode");
            if (selectedZipcode === undefined) {
                bookingFormFormik.setFieldError('consigneeZipcode', 'Please select a valid zipcode from list');
            } else {
                bookingFormFormik.setFieldValue('consigneeZipcode', selectedZipcode?.pin || '');
            }
        }

    }, [bookingFormFormik?.values?.consigneeCity, bookingFormFormik?.values?.consigneeState, bookingFormFormik?.values?.consigneeCountry, bookingFormFormik?.values?.consigneeZipcode]);

    const onHandleAcceptBids = () => {
        console.log("Accept Bids Clicked");
        console.log(summaryItem, "summaryItem");
        const url = '?summeryId=' + summaryItem?.id + '&statusId=' + status_master?.find((item) => item?.statusCode === BID_ACCEPTED)?.id + '&inquiryId=' + summaryItem?.inquiryId;
        dispatch(postTransferStatusData(url))
        setTimeout(() => {
            navigate('/my/inquiries');
        }, 300)
    }

    useEffect(() => {
        //console.log(bookingFormFormik?.errors, "errors")
        setErrorItem(bookingFormFormik?.errors);
    }, [bookingFormFormik?.errors])

    const isConsigneeSameAsBilling = async (isCopy) => {
        console.log("Consignee Same As Billing", isCopy);
        console.log(billingInfo, "billingInfo");
        if (isCopy) {
            await bookingFormFormik.setFieldValue('consigneeFirstName', billingInfo?.label || billingInfo?.firstName || '');
            bookingFormFormik.setFieldTouched('consigneeFirstName', true, true);
            bookingFormFormik.setFieldValue('consigneeLastName', billingInfo?.lastName || '');
            await bookingFormFormik.setFieldValue('consigneePhoneNumber', billingInfo?.contactNo || billingInfo?.contactNumber || '');
            bookingFormFormik.setFieldTouched('consigneePhoneNumber', true, true);
            bookingFormFormik.setFieldValue('consigneeEmail', billingInfo?.contactEmail || billingInfo?.email || '');
            bookingFormFormik.setFieldValue('consigneeCompanyName', '');
            bookingFormFormik.setFieldValue('consigneeCompanyAddress', billingInfo?.address || '');
            await bookingFormFormik.setFieldValue('consigneeCityId', billingInfo?.city?.id || 0, true);
            await bookingFormFormik.setFieldValue('consigneeCity', billingInfo?.city?.cityName || '', true);
            bookingFormFormik.setFieldTouched('consigneeCityId', true, true); // true triggers validation
            bookingFormFormik.setFieldTouched('consigneeCity', true, true); // true triggers validation
            bookingFormFormik.setFieldValue('consigneeStateId', billingInfo?.state?.id || 0);
            bookingFormFormik.setFieldValue('consigneeState', billingInfo?.state?.stateName || '');
            bookingFormFormik.setFieldValue('consigneeCountryId', billingInfo?.country?.id || 0);
            bookingFormFormik.setFieldValue('consigneeCountry', billingInfo?.country?.countryName || '');
            bookingFormFormik.setFieldValue('consigneeZipcode', billingInfo?.pinCode?.pin || '');

        } else {
            bookingFormFormik.setFieldValue('consigneeFirstName', '');
            bookingFormFormik.setFieldValue('consigneeLastName', '');
            bookingFormFormik.setFieldValue('consigneePhoneNumber', '');
            bookingFormFormik.setFieldValue('consigneeEmail', '');
            bookingFormFormik.setFieldValue('consigneeCompanyName', '');
            bookingFormFormik.setFieldValue('consigneeCompanyAddress', '');
            bookingFormFormik.setFieldValue('consigneeCityId', '');
            bookingFormFormik.setFieldValue('consigneeCity', '');
            bookingFormFormik.setFieldValue('consigneeStateId', '');
            bookingFormFormik.setFieldValue('consigneeState', '');
            bookingFormFormik.setFieldValue('consigneeCountryId', '');
            bookingFormFormik.setFieldValue('consigneeCountry', '');
            bookingFormFormik.setFieldValue('consigneeZipcode', '');
        }
    }

    const isShipperSameAsBilling = async (isCopy) => {
        if (isCopy) {
            console.log("Shipper Same As Billing", isCopy);
            console.log(billingInfo, "billingInfo");
            await bookingFormFormik.setFieldValue('firstName', billingInfo?.label || billingInfo?.firstName || '', true);
            bookingFormFormik.setFieldTouched('firstName', true, true);
            bookingFormFormik.setFieldValue('lastName', billingInfo?.lastName || '');
            await bookingFormFormik.setFieldValue('contactNumber', billingInfo?.contactNo || billingInfo?.contactNumber || '');
            bookingFormFormik.setFieldTouched('contactNumber', true, true);
            bookingFormFormik.setFieldValue('email', billingInfo?.contactEmail || billingInfo?.email || '');
            bookingFormFormik.setFieldValue('companyAddress', billingInfo?.address || '');
            bookingFormFormik.setFieldValue('shipperCityId', billingInfo?.city?.id || 0);
            bookingFormFormik.setFieldValue('shipperCity', billingInfo?.city?.cityName || '');
            bookingFormFormik.setFieldValue('shipperStateId', billingInfo?.state?.id || 0);
            await bookingFormFormik.setFieldValue('shipperState', billingInfo?.state?.stateName || '', true);
            bookingFormFormik.setFieldValue('shipperCountryId', billingInfo?.country?.id || 0);
            await bookingFormFormik.setFieldValue('shipperCountry', billingInfo?.country?.countryName || '', true);
            await bookingFormFormik.setFieldValue('shipperZipcode', billingInfo?.pinCode?.pin || '', true);
        }
        else {
            bookingFormFormik.setFieldValue('firstName', "");
            bookingFormFormik.setFieldValue('lastName', "");
            bookingFormFormik.setFieldValue('contactNumber', "");
            bookingFormFormik.setFieldValue('email', "");
            bookingFormFormik.setFieldValue('companyAddress', "");
            bookingFormFormik.setFieldValue('shipperCityId', 0);
            bookingFormFormik.setFieldValue('shipperCity', "");
            bookingFormFormik.setFieldValue('shipperStateId', 0);
            bookingFormFormik.setFieldValue('shipperState', "");
            bookingFormFormik.setFieldValue('shipperCountryId', 0);
            bookingFormFormik.setFieldValue('shipperCountry', "");
            bookingFormFormik.setFieldValue('shipperZipcode', "");
        }
    }

    const hasKeyWithValue = (key) => !!errorItem[key];
    const hasAnyError = (keys) => keys.some(key => hasKeyWithValue(key));

    const highlightError = (errorObject) => {
        // If errorObject is an object with multiple keys, show all errors
        if (typeof errorObject === "object" && errorObject !== null) {
            Object.entries(errorObject).forEach(([key, err]) => {
                if (typeof err === "string") {
                    showErrorToast(`${err}`);
                } else if (typeof err === "object" && err !== null) {
                    // Nested error object (e.g., for arrays or nested fields)
                    Object.entries(err).forEach(([nestedKey, nestedErr]) => {
                        if (typeof nestedErr === "string") {
                            showErrorToast(`${key}.${nestedKey}: ${nestedErr}`);
                        }
                    });
                }
            });
        } else {
            showErrorToast(errorObject);
        }
    }

    return (
        <>
            <div className="page-content settings_wrapper">
                <TopBreadcrumbs breadcrumbs={instantRateBookingBreadcrumb} />
                <Container fluid>
                    <Row>
                        {/* ------------------- */}
                        <div className="col-12 col-md-8">
                            <PerfectScrollbar className="p-1" style={{ height: `${height}px` }}>
                                <div className="modal-body">
                                    {quoteData?.length !== 0 && item !== null && inquiryId !== null ? (
                                        <Accordion flush open={open} toggle={toggle} className='main_accordion'>
                                            <AccordionItem>
                                                <AccordionHeader className="instant-rate-booking-accordion-header" targetId={`flightDetails`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'flightDetails' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={hasKeyWithValue('cargo_value') ? { color: 'red', width: "32px" } : { width: "32px" }}>1</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'flightDetails' ? "c-neutral-900" : "c-neutral-grey"}`} style={hasKeyWithValue('cargo_value') ? { color: 'red' } : {}}>Shipment Details</span>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={`flightDetails`}>
                                                    <ShipmentInformationForm bookingFormik={bookingFormFormik} bookingType={bookingType} proceedToNext={proceedToNext} bookingFrom={bookingFrom} inquiryId={inquiryId} />
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem>
                                                <AccordionHeader className="instant-rate-booking-accordion-header" targetId={`billingdetails`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'billingdetails' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={hasKeyWithValue('billingCustomerName') ? { color: 'red', width: "32px" } : { width: "32px" }}>2</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'billingdetails' ? "c-neutral-900" : "c-neutral-grey"}`} style={hasKeyWithValue('billingCustomerName') ? { color: 'red' } : {}}>Billing Details</span>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={`billingdetails`}>
                                                    <BillingInformation formik={bookingFormFormik} proceedToNext={proceedToNext} setBillingInfo={setBillingInfo} />
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem>
                                                <AccordionHeader onClick={() => { dispatch({ type: SETTINGS_INITIALIZE }); }} className="instant-rate-booking-accordion-header" targetId={`customerdetails`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'customerdetails' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={hasAnyError([
                                                        'contactNumber',
                                                        'firstName',
                                                        'shipperCity',
                                                    ]) ? { color: 'red', width: "32px" } : { width: "32px" }}>3</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'customerdetails' ? "c-neutral-900" : "c-neutral-grey"}`} style={hasAnyError([
                                                        'contactNumber',
                                                        'firstName',
                                                        'shipperCity',
                                                    ]) ? { color: 'red' } : {}}>Shipper Details</span>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={`customerdetails`}>
                                                    <TenantsInformationForm companyDetailsFormik={bookingFormFormik} proceedToNext={proceedToNext} activeItem={open} isCopyShipperSameAsBilling={isShipperSameAsBilling} onShipperCountryChange={onShipperCountryChange} />
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem>
                                                <AccordionHeader onClick={() => { dispatch({ type: SETTINGS_INITIALIZE }); }} className="instant-rate-booking-accordion-header" targetId={`consigneedetails`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'consigneedetails' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={hasAnyError([
                                                        'consigneeFirstName',
                                                        'consigneePhoneNumber',
                                                        'consigneeCity',
                                                        'consigneeCityId'
                                                    ]) ? { color: 'red', width: "32px" } : { width: "32px" }}>4</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'consigneedetails' ? "c-neutral-900" : "c-neutral-grey"}`} style={hasAnyError([
                                                        'consigneeFirstName',
                                                        'consigneePhoneNumber',
                                                        'consigneeCity',
                                                        'consigneeCityId'
                                                    ]) ? { color: 'red' } : {}}>Consignee Details</span>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={`consigneedetails`}>
                                                    {/* <AirConsigneeForm proceedToNext={proceedToNext}/> */}
                                                    <ConsigneeForm bookingFormik={bookingFormFormik} proceedToNext={proceedToNext} activeItem={open} isConsigneeCopyBillingAddress={isConsigneeSameAsBilling} onConsigneeCountryChange={onConsigneeCountryChange} />
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem>
                                                <AccordionHeader className="instant-rate-booking-accordion-header" targetId={`addon`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'addon' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={{ width: "32px" }}>5</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'addon' ? "c-neutral-900" : "c-neutral-grey"}`}>Additional Services</span>
                                                </AccordionHeader>
                                                <AccordionBody className="p-2" accordionId={`addon`}>
                                                    <div className="customer_form_details">
                                                        <Card>
                                                            <CardBody>
                                                                <div className="p-3">
                                                                    <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                                                                        <h6 className="mb-0 fw-medium">Customs at Origin</h6>
                                                                        <div className="square-switch">
                                                                            <Input
                                                                                type="checkbox"
                                                                                id="customs-origin"
                                                                                switch="none"
                                                                                role="switch"
                                                                                checked={isCustomsOriginChecked}
                                                                                onClick={() => setIsCustomsOriginChecked(!isCustomsOriginChecked)}
                                                                                disabled={bookingFrom === 'viewBids'}
                                                                            />
                                                                            <Label htmlFor="customs-origin" data-on-label="Yes" data-off-label="No"></Label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                                                                        <h6 className="mb-0 fw-medium">Customs at Destination</h6>
                                                                        <div className="square-switch">
                                                                            <Input
                                                                                type="checkbox"
                                                                                id="customs-destination"
                                                                                switch="none"
                                                                                role="switch"
                                                                                checked={isCustomsDestinationChecked}
                                                                                onClick={() => setIsCustomsDestinationChecked(!isCustomsDestinationChecked)}
                                                                                disabled={bookingFrom === 'viewBids'}
                                                                            />
                                                                            <Label htmlFor="customs-destination" data-on-label="Yes" data-off-label="No"></Label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <h6 className="mb-0 fw-medium">Insurance</h6>
                                                                        <div className="square-switch">
                                                                            <Input
                                                                                type="checkbox"
                                                                                id="insurance"
                                                                                switch="none"
                                                                                role="switch"
                                                                                checked={isInsuranceChecked}
                                                                                onClick={() => setIsInsuranceChecked(!isInsuranceChecked)}
                                                                                disabled={bookingFrom === 'viewBids'}
                                                                            />
                                                                            <Label htmlFor="insurance" data-on-label="Yes" data-off-label="No"></Label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* <div className="d-flex justify-content-end">
                                                                    <button className="btn btn-primary" onClick={() => {}}>Continue</button>
                                                                </div> */}
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                </AccordionBody>
                                            </AccordionItem>
                                            {/* <AccordionItem>
                                                <AccordionHeader className="instant-rate-booking-accordion-header" targetId={`yourGoods`}>
                                                    <span className={`fs-7 fw-700 ba h-8 br-100 justify-content-center d-sm-flex align-items-center ${open === 'yourGoods' ? 'c-neutral-900' : 'c-neutral-grey'}`} style={{width: "32px"}}>5</span>
                                                    <span className={`fs-7 px-4 fw-600 ${open === 'yourGoods' ? "c-neutral-900" : "c-neutral-grey"}`}>Your Goods</span>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={`yourGoods`}>
                                                    <GoodsConsentForm yourGoodsFormik={yourGoodsFormik} />
                                                </AccordionBody>
                                            </AccordionItem> */}
                                        </Accordion>
                                    ) : (
                                        <div className="text-center p-5">
                                            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-3 text-muted">Loading booking data...</p>
                                        </div>
                                    )}
                                </div>
                            </PerfectScrollbar>
                        </div>
                        <div className="col-12 col-md-4">
                            <div id="sidebar-booking-menu" className="settings_sidebar">
                                <div className="card p-3 shadow-sm">
                                    {/* Total Price Section */}
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h6 className="mb-0">Total price</h6>
                                        </div>
                                        <div className="text-end">
                                            {quoteData.map((item, mainindex) => (
                                                <h5 key={mainindex} className="text-primary mb-0">{getCurrencySymbol(searchForm?.quote_currency?.currencyCode)}{(subTotalHandler(item) || quoteData[0]?.totalCost || 0)}</h5>
                                            ))}
                                            <a href="#"
                                                className="text-primary text-decoration-none"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setIsExpanded(!isExpanded);
                                                }}>
                                                {isExpanded ? "Hide Breakup" : "View Breakup"}
                                            </a>
                                        </div>
                                    </div>

                                    {/* Fare Breakdown */}
                                    <div ref={contentRef}
                                        className="expandable-content"
                                        style={{ overflow: "hidden", transition: "height 0.3s ease" }}>
                                        <div className="mt-3">
                                            {quoteData.map((item, itemIndex) => (
                                                item.tariffDetails.map((details, detailsIndex) =>
                                                    details.selected && (
                                                        <React.Fragment key={detailsIndex}>
                                                            <div className="d-flex justify-content-between">
                                                                <span className="fw-bold">{details.header.replaceAll("_", " ")}</span>
                                                            </div>
                                                            {details.fclTariffBreakDowns?.length === 0 && (
                                                                <div key={`${detailsIndex}-blank-lst`}
                                                                    className="d-flex justify-content-between mb-1">
                                                                    <span style={{ fontSize: "small", color: "rgb(120 112 112)" }}>
                                                                        -
                                                                    </span>
                                                                    <span className="fw-bold">{getCurrencySymbol(searchForm?.quote_currency?.currencyCode)}0</span>
                                                                </div>
                                                            )}
                                                            {details.fclTariffBreakDowns.map((tariffBreakDown, index) => (
                                                                <div key={`${itemIndex}-${detailsIndex}-${index}-lst`}
                                                                    className="d-flex justify-content-between mb-1">
                                                                    <span style={{ fontSize: "small", color: "rgb(120 112 112)" }}>
                                                                        {tariffBreakDown.chargeName || `${tariffBreakDown.component} - ${tariffBreakDown.containerDetail}`}
                                                                    </span>
                                                                    <span className="fw-bold">{
                                                                        `${getCurrencySymbol(tariffBreakDown?.currencyCode || tariffBreakDown?.currency)} ${tariffBreakDown.totalSaleCost || tariffBreakDown?.amount || 0}`
                                                                    }</span>
                                                                </div>
                                                            ))}
                                                        </React.Fragment>
                                                    )
                                                )
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                    <div style={{ height: "50px;" }} />
                    <div className={`sticky-box ${isAtBottom ? "footer-fixed" : "move-bottom"}`} style={{ marginRight: '50px' }}>
                        <div className="modal-footer">
                            <div className="btn_wrap">
                                <button type="button" className='btn border_btn' onClick={() => {
                                    blankFieldHandle();
                                    setBookModal(false);
                                }}>Cancel</button>
                                <button type="button" className='btn btn-primary ms-2' onClick={async () => {
                                    const errors = await bookingFormFormik.validateForm();
                                    if (Object.keys(errors).length === 0) {
                                        setConfirmationModal(true);
                                    } else {
                                        highlightError(errors);
                                        bookingFormFormik.setTouched(
                                            Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
                                        );
                                    }
                                }}>Request Booking</button>
                                {/* <button type="button" className='btn btn-primary ms-2' onClick={() => { previewQuotationHandler() }}>Preview Quotation</button> */}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            {confirmationModal && <ConfirmationModal isOpen={confirmationModal} setOpen={setConfirmationModal} buttonText={bookingRequestButtonText} message={bookingRequestMessage} shortMessage={bookingRequestShortMesssage} title={bookingRequestTitle} confirm={(e) => { bookingFormFormik.handleSubmit(); setConfirmationModal(false); }} />}
        </>
    );
}

export default BookingForm;
